import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { Link } from "react-router-dom";
import EduPagination from "../edu-pagination/edu-pagination";
import JobScheduleCampusEdit from "./job-schedule-campus-edit";

export function JobScheduleCampus() {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [campusList, setCampusList] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState("");
  const [selectJobScheduleCampusRow, setSelectJobScheduleCampusRow] = useState(
    {}
  );
  const [activateJobScheduleCampusEdit, setActivateJobScheduleCampusEdit] =
    useState(false);

  let loginUser = {};
  try {
    loginUser = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
  }

  let CampusList = async () => {
    try {
      let response = await axios(`${baseUrl}/get_campus/`, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200) {
        setCampusList(response?.data?.data || []);
      }
    } catch (error) {
      setCampusList([]);
    }
  };

  useEffect(() => {
    try {
      (async function () {
        await CampusList();
      })();
    } catch (error) {
      console.error("Error :", error.response.data);
    }
  }, [forceUpdate]);

  return (
    <>
      {/* <Header /> */}
      {/* <Sidebar activeItem={"BusManagement"} /> */}
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                College List
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    College List
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row justify-content-end"></div>
              </div>
              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>College</th>
                      <th>College Description</th>
                      <th>Company</th>
                      <th>Schedule Change</th>
                      <th>Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    {campusList.map((arr, i) => {
                      return (
                        <tr key={arr.id}>
                          <td>{++i + pageLimit * (pageNumber - 1)}</td>
                          <td>
                            <span>{arr?.campus_name}</span>
                          </td>
                          <td>
                            <span>{arr?.campus_description}</span>
                          </td>
                          <td>
                            <span>{arr?.company?.name}</span>
                          </td>
                          <td>
                            <Link
                              role="button"
                              className="btn btn-success"
                              data-bs-toggle="modal"
                              data-bs-target="#editjobschedulecampus"
                              onClick={() => {
                                setSelectJobScheduleCampusRow(arr);
                                setActivateJobScheduleCampusEdit(true);
                              }}
                            >
                              <i className="fa  fa-calendar" />
                            </Link>
                          </td>
                          <td>
                            {arr?.days?.map((day, index) => {
                              return (
                                <span
                                  key={index}
                                  className="badge bg-secondary me-1"
                                >
                                  {day.substring(0, 3)}
                                </span>
                              );
                            })}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <EduPagination
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  totalCount={totalCount}
                />
              </div>
            </div>
          </div>
        </div>
        <JobScheduleCampusEdit
          selectJobScheduleCampusRow={selectJobScheduleCampusRow}
          setSelectJobScheduleCampusRow={setSelectJobScheduleCampusRow}
          setForceUpdate={setForceUpdate}
          forceUpdate={forceUpdate}
          activateJobScheduleCampusEdit={activateJobScheduleCampusEdit}
          setActivateJobScheduleCampusEdit={setActivateJobScheduleCampusEdit}
        />
      </section>
    </>
  );
}
